<template>
  <!-- 照明策略  deng-->
  <div class="applicationtype">
    <div class="customizePage">
      <div class="content" style="border: 1px solid black; ">
        <areaed ref="areaed" :show_edit="false" style="margin-top: 10px;" @eventName="aaa"></areaed>
        <div class="box">
          <div class="li" v-for="(e,i) in tableData" :key="i">
            <div class="title">
              <img class="image" v-if="e.currentValue" src="./ming.png">
              <img class="image" v-else src="./ming_no.png">
              <div class="name">{{(i+1)+e.showName}}</div>
            </div>
            <div class="cent">
              <img class="image" v-if="e.realValue" src="./kai.png">

              <img class="image" v-else src="./guan.png">
              <u-button class="off" style="background-color: #000;color:#fff;border-color: #22a5f1;"
                @click="e.currentValue=!e.currentValue;e.realValue=!e.realValue;">{{e.realValue==1?'关':'开'}}</u-button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {getAllEnergyType,getAllTypeByGroup,getAppTypeByGroupId,saveEnergyType,deleteEnergyType} from "../../api/energySubType";
  import {findAllAppType,apptypeSave,apptypeDeleteById} from "../../api/application";
  import resourcesStore from '@/cache/resourcesStore.js'
  import elIconBtn from '@/components/module/iconBtns.vue'
  import areaed from './areaed.vue'
  export default {
    components: {elIconBtn,areaed},
    data () {
      return {
        Aid: '',
        listDataIn: '',
        tableData: [{
          currentValue: true,
          realValue: true,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },{
          currentValue: true,
          realValue: true,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },{
          currentValue: false,
          realValue: false,
          showName: '号灯'
        },],
        tableData1: [],
        isMask: false,//遮罩层
        loading: true,
        deviceTableData: [{
          deviceno: 3,
          devicename: 'A栋101'
        },
        {
          deviceno: 11,
          devicename: 'A栋201'
        },
        {
          deviceno: 13,
          devicename: 'A栋301'
        },
        {
          deviceno: 22,
          devicename: 'A栋302'
        }],

        searchName: "",//搜索名称
        total: 0,
        topLevel: 0,
        detail_status: false,
        Password: '',
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        heights: document.getElementById('app').clientHeight-250,

        tableDataCopy: [],
        optionsd: {},
        defaultProps: {
          children: "next",
          label: "name"
        },
        dialogVisible: false,
        rules: {
          name: [
            {required: true,message: '请输入类型名称',trigger: 'blur'}
          ],
        },
        options: [],
        typeOptions: [],
        listData: {
          "Page": 1,
          "Rows": 10
        },

        columns: [
          {
            name: "编码",
            // key: "Code",
            key: "no",
            width: 90,
            al: 'center'
          },{
            name: "类型",
            // key: "Coefficient",
            key: "entityName",
            width: 90,
            al: 'center'
          }
        ],
      };
    },
    computed: {
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
    },
    watch: {
      'temp.appType': function(val) {
        // console.log("askdbhk",val);
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }

        getAppTypeByGroupId({'groupId': val}).then(res => {
          // console.log(res);
          if(res.code==200) {
            this.typeOptions=res.data
          }
        })
      },
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
      searchName (val) {
        if(val=='') {
          this.loading=true
          setTimeout(() => {
            this.loading=false
          },1000);
          this.deviceTableData=this.deviceTableDataCopy
        }
      },
    },
    mounted () {

      //应用类型编码
      getAllTypeByGroup().then(res => {
        //  console.log("res应用类型",res);
        this.options=res.data;
        this.getList();//获取列表数据 
      })

    },
    methods: {
      // 删除
      delFun (i) {
        this.$confirm('是否删除此数据','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData.splice(i,1)
          this.$message({showClose: true,message: '删除成功',type: 'success'});
        }).catch(() => {
          // ...
        });

      },
      //搜索列表
      search_fn () {
        this.loading=true
        setTimeout(() => {
          this.loading=false
        },1000);
        this.tableData=this.tableDataCopy.filter((item) => item.name.includes(this.searchName));
      },

      //详情
      detail (v) {
        this.temp=v;
        this.detail_status=true;
      },
      // 删除管理员
      delete_fn (v) {
        this.$confirm(`是否删除 ${v.name}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // console.log(v);
          apptypeDeleteById({'no': v.no}).then(res => {
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.getList();
            } else {
              this.$message.error(`删除失败，${res.message}`);
            }
          })
        }).catch(() => {
          // ...
        });

      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.uid=null
            apptypeSave(this.temp).then(data => {
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v,l) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        // console.log(v);
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            // console.log("this.temp",this.temp);
            // this.temp.uid = this.temp.no
            var d={
              "name": this.temp.name,
              "uid": this.temp.no,
            }
            apptypeSave(d).then(data => {
              // console.log(data);
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


      //获取列表数据
      getList () {

      },


    }
  };
</script>

<style lang="scss" scoped>
  .applicationtype {
    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      box-sizing: border-box;
      background-color: #fff;

    }

    /deep/.el-dialog {
      width: 460px !important;

    }

    .mydialog {
      /deep/.el-input {
        width: 240px !important;
      }
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }



    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

  }
</style>
<style scoped>
  .cent {
    display: flex;
    align-items: center;
    margin-top: 23px;
  }

  .cent .img {
    width: 140px;
    height: 156px;
    margin-right: 16px;
  }

  .off {
    color: #CCC;
    font-family: Microsoft YaHei;
    font-size: 14px;
    border-radius: 8px;
    background: #272A2F;
    width: 76px;
    height: 34px;
    border-radius: 16px;
    text-align: center;
    line-height: 34px;
    margin: 0 7px;
    transform: scale(1.3);
    border: 2px solid #22a7f2;
    background: #1B1E23;
  }


  .box {
    padding-left: 16px;
    padding-top: 15px;
    display: flex;
    flex-wrap: wrap;
    background: #000;
  }

  .box .li {
    border-radius: 8px;
    background: #1B1E23;
    width: 283px;
    height: 235px;
    box-sizing: border-box;
    padding: 16px;
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .li .title {
    display: flex;
    align-items: center;
    line-height: normal;
  }

  .li .title .text {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .li .title .text view {
    background: #11EF6A;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .li .title .text {
    color: #CCC;
    font-size: 12px;
  }

  .li .title .name {
    color: #FFF;
    font-weight: bold;
    font-size: 14px;
  }

  .li .title .image {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: #000;
    margin-right: 8px;
  }

  .customizePage {
    background-color: black;
    height: 100vh;
    width: 100%;
    box-sizing: border-box;
  }
</style>